import styled from 'styled-components'
import { HeightClass } from '~/utils/enum/classes'
import { getBorderColor, getBorderWidth } from './HierarchyCard.data'

export const Container = styled.div`
  width: 100%;
  background-color: white;
`

export const Content = styled.div<{
  level: number
  spacingClass: HeightClass
}>`
  border-color: ${({ level }) => getBorderColor(level)};
  border-width: ${({ level }) => getBorderWidth(level)};
  border-style: solid;
  border-radius: 6px;
  padding: ${({ theme, spacingClass }) => theme.card[spacingClass]?.padding}px;

  @media (max-width: 768px) {
    padding: 8px;
  }
`
